var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExploreJobs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150.633,
    height: 154.341,
    viewBox: "0 0 150.633 154.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1646",
    "data-name": "Rectangle 1646",
    width: 28.551,
    height: 7.124,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1662",
    "data-name": "Rectangle 1662",
    width: 23.054,
    height: 7.123,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1677",
    "data-name": "Rectangle 1677",
    width: 41.025,
    height: 10.236,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1678",
    "data-name": "Rectangle 1678",
    width: 6.096,
    height: 4.547,
    fill: "#b2caff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1702",
    "data-name": "Rectangle 1702",
    width: 35.893,
    height: 30.636,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1701",
    "data-name": "Rectangle 1701",
    width: 35.89,
    height: 30.636,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1704",
    "data-name": "Rectangle 1704",
    width: 39.502,
    height: 34.366,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12766",
    "data-name": "Group 12766",
    transform: "translate(-794.951 -862.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10359",
    "data-name": "Path 10359",
    d: "M130.463,349.651c0,2.781-29.205,5.035-65.232,5.035S0,352.432,0,349.651s29.205-5.035,65.232-5.035,65.232,2.255,65.232,5.035",
    transform: "translate(815.121 661.758)",
    fill: "#7586ec",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10360",
    "data-name": "Path 10360",
    d: "M152.218,215.143H125.056a.694.694,0,0,1-.695-.695V203.121a.7.7,0,0,1,.695-.695h27.163a.7.7,0,0,1,.695.695v11.328a.694.694,0,0,1-.695.695",
    transform: "translate(746.061 740.721)",
    fill: "#bbd5fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9229",
    "data-name": "Group 9229",
    transform: "translate(870.422 943.146)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9228",
    "data-name": "Group 9228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9227",
    "data-name": "Group 9227",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10362",
    "data-name": "Path 10362",
    d: "M152.218,202.427h-27.16a.693.693,0,0,0-.694.694v3.634l14.143,2.782a.64.64,0,0,0,.263,0l14.145-2.782v-3.634a.7.7,0,0,0-.7-.694",
    transform: "translate(-124.364 -202.427)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10363",
    "data-name": "Path 10363",
    d: "M152.083,187.521h-8.3v-1.392a2.173,2.173,0,0,0-2.17-2.17h-7.411a2.173,2.173,0,0,0-2.17,2.17v1.392h-8.3a.685.685,0,0,0-.685.685v6.851a.685.685,0,0,0,.553.672l14.172,2.787a.677.677,0,0,0,.264,0l14.172-2.787a.684.684,0,0,0,.552-.672v-6.851a.685.685,0,0,0-.685-.685m-18.4-1.392a.529.529,0,0,1,.522-.522h7.411a.529.529,0,0,1,.522.522v1.392h-8.455Z",
    transform: "translate(746.785 750.977)",
    fill: "#bbd5fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10365",
    "data-name": "Path 10365",
    d: "M155.283,215.659h-2.929A.659.659,0,0,1,151.7,215v-1.851a.658.658,0,0,1,.656-.656h2.929a.659.659,0,0,1,.657.656V215a.659.659,0,0,1-.657.657",
    transform: "translate(730.879 735.129)",
    fill: "#a2b0e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10374",
    "data-name": "Path 10374",
    d: "M57.052,215.143H29.89a.694.694,0,0,1-.695-.695V203.121a.7.7,0,0,1,.695-.695H57.052a.7.7,0,0,1,.695.695v11.328a.694.694,0,0,1-.695.695",
    transform: "translate(798.908 740.721)",
    fill: "#bbd5fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9253",
    "data-name": "Group 9253",
    transform: "translate(828.105 943.146)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9252",
    "data-name": "Group 9252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9251",
    "data-name": "Group 9251",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10376",
    "data-name": "Path 10376",
    d: "M57.052,202.427H29.892a.693.693,0,0,0-.694.694v3.634l14.142,2.782a.64.64,0,0,0,.263,0l14.146-2.782v-3.634a.7.7,0,0,0-.7-.694",
    transform: "translate(-29.198 -202.427)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10377",
    "data-name": "Path 10377",
    d: "M56.918,187.521h-8.3v-1.392a2.173,2.173,0,0,0-2.17-2.17H39.041a2.173,2.173,0,0,0-2.17,2.17v1.392h-8.3a.685.685,0,0,0-.685.685v6.851a.685.685,0,0,0,.553.672l14.171,2.787a.68.68,0,0,0,.265,0l14.172-2.787a.684.684,0,0,0,.552-.672v-6.851a.685.685,0,0,0-.685-.685m-18.4-1.392a.529.529,0,0,1,.522-.522h7.411a.529.529,0,0,1,.522.522v1.392H38.519Z",
    transform: "translate(799.633 750.977)",
    fill: "#bbd5fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10388",
    "data-name": "Path 10388",
    d: "M53.495,123.167H29.886a.7.7,0,0,1-.7-.7V111.145a.671.671,0,0,1,.058-.273.617.617,0,0,1,.062-.116.7.7,0,0,1,.087-.1.694.694,0,0,1,.492-.2H52.25a29.278,29.278,0,0,0-.182,4.679c.008.252.021.5.041.757.029.463.066.935.12,1.4a29.824,29.824,0,0,0,1.266,5.879",
    transform: "translate(798.91 791.797)",
    fill: "#bbd5fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9277",
    "data-name": "Group 9277",
    transform: "translate(828.105 902.248)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9276",
    "data-name": "Group 9276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9275",
    "data-name": "Group 9275",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10390",
    "data-name": "Path 10390",
    d: "M52.255,110.45a29.276,29.276,0,0,0-.182,4.679c.008.252.02.5.041.757l-6.52,1.278-1.989.393a.58.58,0,0,1-.265,0l-1.985-.389L29.2,114.777v-3.636a.729.729,0,0,1,.054-.269.629.629,0,0,1,.062-.116.7.7,0,0,1,.087-.1.694.694,0,0,1,.492-.2Z",
    transform: "translate(-29.2 -110.45)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10391",
    "data-name": "Path 10391",
    d: "M52.457,95.546H48.622V94.152a2.173,2.173,0,0,0-2.172-2.168H39.042a2.171,2.171,0,0,0-2.172,2.168v1.394H28.576a.684.684,0,0,0-.687.683v6.851a.69.69,0,0,0,.554.674l.025,0h0l12.154,2.4,1.985.389a.715.715,0,0,0,.265,0l1.99-.393,6.478-1.274a29.725,29.725,0,0,1,1.113-9.328M38.516,94.152a.531.531,0,0,1,.526-.521h7.409a.527.527,0,0,1,.521.521v1.394H38.516Z",
    transform: "translate(799.633 802.053)",
    fill: "#bbd5fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10393",
    "data-name": "Path 10393",
    d: "M60.117,123.68H57.188a.658.658,0,0,1-.656-.657v-1.851a.658.658,0,0,1,.656-.656h2.929a.659.659,0,0,1,.657.656v1.851a.659.659,0,0,1-.657.657",
    transform: "translate(783.727 786.207)",
    fill: "#a2b0e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10395",
    "data-name": "Path 10395",
    d: "M220.221,215.143h27.163a.694.694,0,0,0,.695-.695V203.121a.7.7,0,0,0-.695-.695H220.221a.7.7,0,0,0-.695.695v11.328a.694.694,0,0,0,.695.695",
    transform: "translate(693.213 740.721)",
    fill: "#bbd5fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9289",
    "data-name": "Group 9289",
    transform: "translate(912.738 943.146)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9288",
    "data-name": "Group 9288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9287",
    "data-name": "Group 9287",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10397",
    "data-name": "Path 10397",
    d: "M220.222,202.427h27.16a.693.693,0,0,1,.694.694v3.634l-14.143,2.782a.638.638,0,0,1-.263,0l-14.145-2.782v-3.634a.7.7,0,0,1,.7-.694",
    transform: "translate(-219.525 -202.427)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10398",
    "data-name": "Path 10398",
    d: "M218.906,187.521h8.3v-1.392a2.173,2.173,0,0,1,2.17-2.17h7.411a2.173,2.173,0,0,1,2.17,2.17v1.392h8.3a.685.685,0,0,1,.685.685v6.851a.685.685,0,0,1-.553.672l-14.171,2.787a.68.68,0,0,1-.265,0l-14.172-2.787a.684.684,0,0,1-.552-.672v-6.851a.685.685,0,0,1,.685-.685m18.4-1.392a.529.529,0,0,0-.522-.522h-7.411a.529.529,0,0,0-.522.522v1.392H237.3Z",
    transform: "translate(693.938 750.977)",
    fill: "#bbd5fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10400",
    "data-name": "Path 10400",
    d: "M247.514,215.659h2.929A.659.659,0,0,0,251.1,215v-1.851a.658.658,0,0,0-.656-.656h-2.929a.659.659,0,0,0-.657.656V215a.659.659,0,0,0,.657.657",
    transform: "translate(678.035 735.129)",
    fill: "#a2b0e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10409",
    "data-name": "Path 10409",
    d: "M229.083,123.167h23.609a.7.7,0,0,0,.7-.7V111.145a.678.678,0,0,0-.058-.273.615.615,0,0,0-.062-.116.7.7,0,0,0-.087-.1.694.694,0,0,0-.492-.2h-22.36a29.279,29.279,0,0,1,.182,4.679c-.008.252-.021.5-.041.757-.029.463-.066.935-.12,1.4a29.825,29.825,0,0,1-1.266,5.879",
    transform: "translate(687.906 791.797)",
    fill: "#bbd5fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9313",
    "data-name": "Group 9313",
    transform: "translate(918.234 902.248)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9312",
    "data-name": "Group 9312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9311",
    "data-name": "Group 9311",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10411",
    "data-name": "Path 10411",
    d: "M231.884,110.45a29.276,29.276,0,0,1,.182,4.679c-.008.252-.02.5-.041.757l6.52,1.278,1.989.393a.58.58,0,0,0,.265,0l1.985-.389,12.154-2.391v-3.636a.719.719,0,0,0-.054-.269.6.6,0,0,0-.062-.116.7.7,0,0,0-.087-.1.694.694,0,0,0-.492-.2Z",
    transform: "translate(-231.884 -110.45)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10412",
    "data-name": "Path 10412",
    d: "M229.791,95.546h3.835V94.152a2.173,2.173,0,0,1,2.172-2.168h7.409a2.17,2.17,0,0,1,2.171,2.168v1.394h8.295a.684.684,0,0,1,.687.683v6.851a.69.69,0,0,1-.554.674l-.025,0h0l-12.154,2.4-1.985.389a.715.715,0,0,1-.265,0l-1.99-.393-6.478-1.274a29.725,29.725,0,0,0-1.113-9.328m13.941-1.394a.531.531,0,0,0-.525-.521H235.8a.527.527,0,0,0-.521.521v1.394h8.455Z",
    transform: "translate(687.512 802.053)",
    fill: "#bbd5fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10414",
    "data-name": "Path 10414",
    d: "M247.514,123.68h2.929a.658.658,0,0,0,.656-.657v-1.851a.658.658,0,0,0-.656-.656h-2.929a.659.659,0,0,0-.657.656v1.851a.659.659,0,0,0,.657.657",
    transform: "translate(678.035 786.207)",
    fill: "#a2b0e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10416",
    "data-name": "Path 10416",
    d: "M153.595,122.514h-39.03a1,1,0,0,1-1-1V105.239a1,1,0,0,1,1-1h39.03a1,1,0,0,1,1,1v16.277a1,1,0,0,1-1,1",
    transform: "translate(752.055 795.246)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10417",
    "data-name": "Path 10417",
    d: "M154.568,86.683H143.919a3.05,3.05,0,0,1-3.046-3.046V80.915a3.05,3.05,0,0,1,3.046-3.046h10.649a3.049,3.049,0,0,1,3.046,3.046v2.722a3.049,3.049,0,0,1-3.046,3.046m-10.649-6.591a.824.824,0,0,0-.823.823v2.722a.824.824,0,0,0,.823.823h10.649a.824.824,0,0,0,.823-.823V80.915a.824.824,0,0,0-.823-.823Z",
    transform: "translate(736.891 809.891)",
    fill: "#b2caff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9322",
    "data-name": "Group 9322",
    transform: "translate(865.623 899.486)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9321",
    "data-name": "Group 9321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9320",
    "data-name": "Group 9320",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10418",
    "data-name": "Path 10418",
    d: "M153.6,104.243H114.569a1,1,0,0,0-1,1v5.222l20.321,4a.935.935,0,0,0,.378,0l20.326-4V105.24a1,1,0,0,0-1-1",
    transform: "translate(-113.572 -104.243)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10419",
    "data-name": "Path 10419",
    d: "M153.591,101.011l-20.363,4.006a.994.994,0,0,1-.38,0l-20.363-4.006a.984.984,0,0,1-.794-.965V90.2a.984.984,0,0,1,.984-.985H153.4a.984.984,0,0,1,.984.985v9.844a.984.984,0,0,1-.794.965",
    transform: "translate(753.096 803.588)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10420",
    "data-name": "Path 10420",
    d: "M158,123.257H153.79a.946.946,0,0,1-.943-.944v-2.66a.946.946,0,0,1,.943-.943H158a.946.946,0,0,1,.944.944v2.66a.946.946,0,0,1-.944.944",
    transform: "translate(730.242 787.211)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9325",
    "data-name": "Group 9325",
    transform: "translate(883.088 905.92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9324",
    "data-name": "Group 9324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9323",
    "data-name": "Group 9323",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10421",
    "data-name": "Path 10421",
    d: "M158,123.257H153.79a.946.946,0,0,1-.943-.944v-2.66a.946.946,0,0,1,.943-.943H158a.946.946,0,0,1,.944.944v2.66a.946.946,0,0,1-.944.944",
    transform: "translate(-152.847 -118.71)",
    fill: "#b2caff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10536",
    "data-name": "Path 10536",
    d: "M155.283,215.659h-2.929A.659.659,0,0,1,151.7,215v-1.851a.658.658,0,0,1,.656-.656h2.929a.659.659,0,0,1,.657.656V215a.659.659,0,0,1-.657.657",
    transform: "translate(688.557 735.127)",
    fill: "#a2b0e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10504",
    "data-name": "Path 10504",
    d: "M102.789,736.292l2,8.405,2.989-.017.11-8.388Z",
    transform: "translate(708.91 261.479)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10505",
    "data-name": "Path 10505",
    d: "M257.112,732.807l5.678,8.047L265,738.012l-3.418-6.312Z",
    transform: "translate(579.732 265.322)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10506",
    "data-name": "Path 10506",
    d: "M28.108,72.959a13.568,13.568,0,0,0,1.016-4.678,14.349,14.349,0,0,1-1.67,5.17C22.489,76.711,12.973,87.6,13.161,89.658c0,0-1.051-.986-2.576-2.387l-.352-2.119a4.183,4.183,0,0,0-.194,1.618C7.19,84.157,3.1,80.474.918,78.812a26.426,26.426,0,0,1,1.026-2.5c-.638.176-1.394,1.346-1.762,1.968C.118,78.237.058,78.2,0,78.164c0,0,.651-5.138,8.057-8.975,3.882-2.011,6.545-2.844,6.389-5.4s1.016-13.538,8.477-10.663a4.859,4.859,0,0,1,1.734-.452,1.465,1.465,0,0,0-.661.314,5.79,5.79,0,0,1,3.134.6c2.735,1.554,5.183,15.5.979,19.369",
    transform: "translate(794.951 833.729)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10507",
    "data-name": "Path 10507",
    d: "M130.58,143.529c.025.011-2.4,1.269-4.219.77-1.714-.467-2.833-2.689-2.81-2.694.726-.144.935-1.141.92-5.427l.328.065,5.517,1.092s-.126,1.736-.129,3.372c0,1.373.079,2.676.394,2.822",
    transform: "translate(691.531 763.814)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10508",
    "data-name": "Path 10508",
    d: "M136.728,137.667s-.125,1.736-.129,3.371c-3.087-.087-4.719-2.9-5.387-4.464Z",
    transform: "translate(685.117 763.48)",
    fill: "#d68d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10509",
    "data-name": "Path 10509",
    d: "M117.165,74.657a16.223,16.223,0,0,1-2.006-4.742c-.277-1.561.518-7.345,6.33-6.512a7.9,7.9,0,0,1,3.275,1.238c1.262.852,3.083,2.692,1.047,7.74l-.529,1.705Z",
    transform: "translate(698.596 824.799)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10510",
    "data-name": "Path 10510",
    d: "M139.145,431.837l-2.924.089-3.165.1a62.479,62.479,0,0,1-11.412-21.189q-.143-.455-.3-.921c-2.244-6.544-6.9-14.759-9.349-22.194-.39-1.184-.741-2.3-1.055-3.354-.1-.338-.2-.67-.292-1a78.865,78.865,0,0,1-2.812-14.8l17.705.142a330.045,330.045,0,0,0,13.608,63.132",
    transform: "translate(704.689 569.291)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10511",
    "data-name": "Path 10511",
    d: "M87.587,189.112c-.045,8.425,1.236,12.04,1.236,12.04a23.792,23.792,0,0,1-16.591,1.017c-.106-.033-6.776-1.372-6.776-1.372.151-.341,1.991-6.17,2.138-6.482a25.069,25.069,0,0,0,2.389-7.322,26.713,26.713,0,0,0,.219-7.059,56.643,56.643,0,0,0-2.185-11.085,57.6,57.6,0,0,0,7.309-2.5,5.709,5.709,0,0,0,3.943,1.462c1.795-.039,2.377-.808,2.284-1.647,1.913,1.064,3.439,2.07,3.439,2.07,1.626,2.823,4.922,5.565,5.161,9.9.059,1.065-2.564,10.743-2.565,10.979",
    transform: "translate(740.16 738.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10512",
    "data-name": "Path 10512",
    d: "M180.724,176.6c-2.6-3.036-9.334-9.621-16.283-10.429l6,11.682a5.169,5.169,0,0,0,2.113,3.169,34.8,34.8,0,0,0,9.88,4.122,51.9,51.9,0,0,0,8.865-5.385c1.607-1.178,4.431-5.669,4.431-5.669l-.762-2.549s-4.794,2.68-6.507,3.453c-.976.441-3.223,1.493-4.806,2.236a2.47,2.47,0,0,1-2.928-.631",
    transform: "translate(657.303 738.711)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10513",
    "data-name": "Path 10513",
    d: "M133.426,89.469s-7.3.12-7.309-4.429-.951-7.6,3.712-7.867,5.571,1.466,5.942,2.984-.445,9.164-2.345,9.313",
    transform: "translate(689.451 813.229)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10514",
    "data-name": "Path 10514",
    d: "M121.091,71.88s-2,5.338-5.069,6.127-4.4-.033-4.4-.033a8.69,8.69,0,0,0,2.843-5.134s5.118-3.5,6.626-.959",
    transform: "translate(701.516 818.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10515",
    "data-name": "Path 10515",
    d: "M166.7,74.819a6.451,6.451,0,0,1,1.858,2.35c.364,1.159.528,3.544,1.223,3.462,0,0,1.507-3.628-.187-5.68-1.8-2.176-2.894-.133-2.894-.133",
    transform: "translate(655.416 815.904)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10516",
    "data-name": "Path 10516",
    d: "M351.775,182.5a4.559,4.559,0,0,1,5.109-3.186c.468.147,1.836.692.962,2.157-.645,1.08-.924.522-1.937,1.973a3.231,3.231,0,0,1-3.372,1.6Z",
    transform: "translate(500.492 727.752)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10517",
    "data-name": "Path 10517",
    d: "M112.227,784.995a8.1,8.1,0,0,1-.381,3.446s-.489,2.229,1.706,2.271,2.734-.166,2.485-1.533-.721-3.731-.721-3.731Z",
    transform: "translate(701.367 220.711)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10518",
    "data-name": "Path 10518",
    d: "M115.26,809.075s-.047.029-.138.073h-4.3a1.059,1.059,0,0,1-.121-.073,10.788,10.788,0,0,1,.157-3.223c2.487,2.278,4.043-.057,4.043-.057a11.659,11.659,0,0,1,.357,3.28",
    transform: "translate(702.354 203.301)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10519",
    "data-name": "Path 10519",
    d: "M295.372,777.217a54.947,54.947,0,0,1-5.29-6.779l-3.01,1.542L293.8,778.3l1.574-.207Z",
    transform: "translate(554.652 232.896)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10520",
    "data-name": "Path 10520",
    d: "M293.965,787.473h-5.539a7.867,7.867,0,0,1-1.651-2.56,2.714,2.714,0,0,0-1.833-1.225v3.742h-1.149l-1.088-3.978c-.716-1.317-.057-2.511.448-3.551.586,0,2.164.4,5.154,3.769a3.919,3.919,0,0,0,3.146,1.468.274.274,0,0,0,.044.023,4.015,4.015,0,0,1,2.467,2.312",
    transform: "translate(558.572 224.975)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10521",
    "data-name": "Path 10521",
    d: "M164.25,166.167s4.226,10.439,4.35,12.552.5,34.548.5,34.548-.249,1.491,2.61.87,3.6-1.243,3.6-1.243-2.734-20.008-1.988-26.968-5.717-18.31-5.717-18.31Z",
    transform: "translate(657.463 738.711)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10522",
    "data-name": "Path 10522",
    d: "M150.669,497.821l-3.165.1a62.479,62.479,0,0,1-11.412-21.189q-.143-.455-.3-.921c-2.244-6.544-6.9-14.759-9.349-22.194-.39-1.185-.741-2.3-1.055-3.354-.1-.338-.2-.67-.292-1l2.607-1.978s7.828,12.676,10.251,24.605c2.105,10.362,10.536,22.831,12.718,25.931",
    transform: "translate(690.24 503.396)",
    fill: "#262d4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10523",
    "data-name": "Path 10523",
    d: "M73.1,455.719c.045,5.8-.248,19.138-1,24.66h-2.8c-1.55,0-2.323-.022-2.323-.022-1.9-9.6-3.244-17.544-4.225-24.389-.805-5.617-1.521-10.433-2.072-14.579-.554-4.172-.939-7.665-1.077-10.617-.021-.465-.037-.917-.046-1.356s-.011-.87-.008-1.286l15.3-1.491c-.193,10.164-1.765,25.709-1.74,29.08",
    transform: "translate(745.111 520.68)",
    fill: "#262d4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10524",
    "data-name": "Path 10524",
    d: "M69.575,501.615c-1.55,0-2.323-.022-2.323-.022-1.9-9.6-3.244-17.544-4.225-24.389-.805-5.617-1.521-10.433-2.072-14.579-.554-4.172-.939-7.665-1.077-10.617l5.614,3.3s-3.583,1.264-2.216,10.833,4.4,34.117,6.3,35.472",
    transform: "translate(744.83 499.443)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10525",
    "data-name": "Path 10525",
    d: "M52.749,213.739s-1.077,3.894-4.806,3.4a44.935,44.935,0,0,1-9.03-2.734s1.593-5.034,3.574-11.648c2.4-8.007,5.367-18.329,6.767-24.84a40.262,40.262,0,0,0,.76-4.439l3.093-6s4.612,10.351,4.86,12.96-5.22,33.306-5.22,33.306",
    transform: "translate(762.377 737.617)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10526",
    "data-name": "Path 10526",
    d: "M70.945,239.537c-.167,4.225-1.161,12.428-10.025,16.818-.024.011-.047.024-.071.034,2.4-8.007,5.367-18.329,6.767-24.84,1.628,2.433,3.42,5.662,3.329,7.988",
    transform: "translate(744.016 683.982)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10527",
    "data-name": "Path 10527",
    d: "M67.5,180.045l4.082-12.572a63,63,0,0,0-7.744,2.838s-1.618,2.086-2.619,6.9c0,0-1.057,11.551,1.3,15.777,0,0,7.457,1.491,19.387-2.61v-2.734s-13.049.684-15.721.994Z",
    transform: "translate(743.902 737.617)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10528",
    "data-name": "Path 10528",
    d: "M69.549,167.473s-7.568.533-9.39,4.593-2.4,17.564-.083,21.541c0,0,3.194.91,8.843-.147l.209-.04s1.8-4.412.186-5.282c0,0-4.764.248-4.267-1.326s4.5-19.34,4.5-19.34",
    transform: "translate(745.938 737.617)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10529",
    "data-name": "Path 10529",
    d: "M181.21,269.086a6.525,6.525,0,0,0,1.261-2.546,2.768,2.768,0,0,1,2.7-2.476c1.794-.236,2.566-.261,2.561.244a13.39,13.39,0,0,1-4.041,6.146c-2.575,2.109-2.486-1.368-2.486-1.368",
    transform: "translate(643.268 656.9)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9385",
    "data-name": "Group 9385",
    transform: "translate(854.475 882.387)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9384",
    "data-name": "Group 9384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9383",
    "data-name": "Group 9383",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9382",
    "data-name": "Group 9382",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9381",
    "data-name": "Group 9381",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10530",
    "data-name": "Path 10530",
    d: "M401.214,31.7a22.1,22.1,0,0,0-6.638-3.575L365.321,51.5a21.985,21.985,0,0,0,1.608,6.334c.135.312.272.621.417.927Z",
    transform: "translate(-365.324 -28.126)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9390",
    "data-name": "Group 9390",
    transform: "translate(858.678 888.891)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9389",
    "data-name": "Group 9389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9388",
    "data-name": "Group 9388",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9387",
    "data-name": "Group 9387",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9386",
    "data-name": "Group 9386",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10531",
    "data-name": "Path 10531",
    d: "M430.623,76.977a22.286,22.286,0,0,0-4.733-8.926L391.121,95.833a22.253,22.253,0,0,0,7.661,6.583l31.841-25.44",
    transform: "translate(-391.121 -68.051)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10532",
    "data-name": "Path 10532",
    d: "M.024,68.483a4.712,4.712,0,0,0,2.216,4.489,4.484,4.484,0,0,0,2.128.723,3.118,3.118,0,0,0,1.615-.316L8.828,71.97c1.9-.936,3.781-1.9,5.677-2.854s3.767-1.942,5.651-2.91c1.872-.991,3.754-1.965,5.617-2.974q5.609-2.992,11.138-6.144,2.765-1.577,5.5-3.2a2.447,2.447,0,0,1,3.269.7,34.692,34.692,0,1,0-4.642-9.4A2.448,2.448,0,0,1,39.608,48.2c-1.973.786-3.934,1.6-5.889,2.422q-5.863,2.477-11.65,5.106c-1.935.867-3.851,1.768-5.777,2.651-1.913.911-3.834,1.805-5.743,2.722s-3.82,1.832-5.718,2.771l-2.852,1.4A3.11,3.11,0,0,0,.745,66.356a4.479,4.479,0,0,0-.721,2.129m86.2-9.236h0A27.372,27.372,0,0,1,49.564,46.818h0A27.374,27.374,0,1,1,86.225,59.249",
    transform: "translate(807.834 879.125) rotate(-9)",
    fill: "#040227"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreJobs);
export default __webpack_public_path__ + "static/media/explore-jobs.d83d966ac6ccd9274feabf9130f33e14.svg";
export { ForwardRef as ReactComponent };